<router-outlet></router-outlet>

<footer class="footer">
  Copyright &copy; 2022-{{ currentYear }} <a href="https://anystupididea.com">Any Stupid Idea</a>
  <span class="footer-links">
    <a href="https://anystupididea.com/privacy.html">Privacy</a> | <a href="https://anystupididea.com/terms.html">Terms</a>
  </span>
</footer>
